'use client';

import H2 from '@/components/typography/h2';
import H3 from '@/components/typography/h3';
import Label from '@/components/typography/label';
import P from '@/components/typography/p';
import { cn } from '@/lib/utils';
import { Dot } from 'lucide-react';

export default function AboutCardSimple() {
    const sections = [
        {
            title: 'Strategie',
            content: (
                <P>
                    Het start bij ons met een behapbare strategie. Geen dik
                    rapport voor in de la, maar een helder recept. Zo brengen we
                    ingewikkelde uitdagingen terug tot een eenvoudig en
                    emotioneel vertrekpunt. Zonder de complexiteit van de echte
                    wereld geweld aan te doen.
                </P>
            ),
            list: [
                'Doelgroepanalyse',
                'Communicatiestrategie',
                'Merkstrategie',
                'Mediastrategie',
            ],
        },
        {
            title: 'Creatie',
            content: (
                <P>
                    Wij bedenken ideeën die mensen lekker maken voor
                    verandering. Smakelijke campagnes, social content,
                    activaties, producten en design. Soms in de vorm van een
                    trui, en ook wel eens een blik soep.
                </P>
            ),
            list: [
                'Creatieve campagnes',
                'Design',
                'Activatie',
                'Content & social',
            ],
        },
        {
            title: 'PR',
            content: (
                <P>
                    Met het grootste en meest diverse foodnetwerk van Nederland
                    zorgen we dat goede verhalen het juiste podium krijgen. Van
                    mainstream nieuwsplatforms tot hyper-specialistische
                    vakmedia en lifestyle magazines.
                </P>
            ),
            list: [
                'Persberichten en pitches',
                'Persevents & pakketten',
                'Doorlopende PR',
                'Influencers & creators',
                'Branded content',
            ],
        },
    ];

    return (
        <div className="bg-beige relative flex flex-col items-center">
            <div className="flex max-w-[769px] justify-center px-5 py-15">
                <div className="mx-auto flex flex-col gap-5 text-center">
                    <H2>Wat maken we</H2>
                    <H3 className="text-center">
                        Bij Food Cabinet maken we strategie, creatie en PR. Los,
                        of – nog effectiever – in een geïntegreerde campagne.
                    </H3>
                </div>
            </div>
            {sections.map((section, index) => (
                <div
                    key={index}
                    className={cn(
                        'bg-beige border-primary sticky top-[53px] flex w-full justify-center border-t px-5 py-15',
                        index === sections.length - 1 && 'border-b',
                    )}
                >
                    <div className="flex w-full max-w-[769px] flex-col gap-5 text-left">
                        {section.title && <H3>{section.title}</H3>}
                        {section.content}
                        {section.list && (
                            <ul className="mt-2 flex flex-wrap gap-3">
                                {section.list.map((item, i) => (
                                    <li key={i}>
                                        <div className="flex items-center gap-2">
                                            <Dot className="bg-primary h-2.5 w-2.5 rounded-full lg:h-3.5 lg:w-3.5" />
                                            <Label>{item}</Label>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                </div>
            ))}
        </div>
    );
}
